import React, { useRef } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";

const MapPicker = ({ onLocationSelect }) => {
  const mapRef = useRef();
  const [selected, setSelected] = React.useState(null);
  const center = { lat: -17.8292, lng: 31.0522 }; // Harare coordinates
  const navigate = useNavigate();

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyA4ZQWDwYRHmhu66Cb1F8DgXbJJrArHYyE",
    libraries: ["places"],
  });

  const handleMapClick = (event) => {
    setSelected({ lat: event.latLng.lat(), lng: event.latLng.lng() });
  };

  const handleConfirmLocation = () => {
    if (selected) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: selected }, (results, status) => {
        if (status === "OK" && results[0]) {
          const locationDetails = {
            address: results[0].formatted_address,
            coordinates: {
              lat: selected.lat,
              lng: selected.lng,
            },
          };
          onLocationSelect(selected, results[0].formatted_address);
          navigate('/AdminCreateBranch', { state: { locationDetails } }); 
        }
      });
    }
  };

  if (loadError) return <div className="p-4 text-red-500">Error loading maps</div>;
  if (!isLoaded) return <div className="p-4">Loading maps...</div>;

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="relative w-11/12 max-w-2xl">
      <div>
        <h4 className="px-4 py-2">Pick Location and Confirm</h4>
      </div>
        <GoogleMap
          ref={mapRef}
          mapContainerStyle={{ height: "70vh", width: "100%" }}
          zoom={10}
          center={center}
          onClick={handleMapClick}
          options={{
            zoomControl: true,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
          }}
        >
          {selected && <Marker position={selected} />}
        </GoogleMap>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t bg-white">
          <button
            onClick={handleConfirmLocation}
            disabled={!selected}
            className="w-full py-2 px-4 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ backgroundColor: 'purple', border: 'none', color: '#fff'}}
          >
            Confirm Location
          </button>
        </div>
      </div>
    </div>
  );
};

export default MapPicker;